import React from 'react';
import FormCard from '../FormCard/FormCard';
import { useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { format, parseISO } from 'date-fns';
import { cs, sk, es, enGB, hu, uk, ru, de, fr, pl } from 'date-fns/locale';
import { useAppContext } from '../../../../Services/AppContext';
import styles from './DatePickerCustom.module.scss';
import { Moment } from 'moment';
import moment from 'moment';

// nebyl cas premyslet
const ll: Record<string, any> = {
	cs: cs,
	sk: sk,
	hu: hu,
	en: enGB,
	ru: ru,
	uk: uk,
	es: es,
	de: de,
	fr: fr,
	pl: pl,
};
for (const l in ll) {
	registerLocale(l, ll[l]);
}

interface Props {
	onChange: (date: Moment) => void;
	value: string;
	highlightDates?: Date[];
	excludeDates?: Date[];
	onMonthChange?: (date: Moment) => void;
	minDate?: string;
	maxDate?: string;
}

const DatePickerCustom: React.FC<Props> = ({
	onChange,
	value,
	highlightDates,
	excludeDates,
	onMonthChange,
	minDate,
	maxDate,
}) => {
	const { language, translation } = useAppContext();

	const [toggled, setToggled] = useState(true);
	const [selected, setSelected] = useState<Date | undefined>(undefined);

	useEffect(() => {
		if (value) {
			setSelected(parseISO(value));
		}
	}, []);

	const handleTogglePicker = () => {
		setToggled(prev => !prev);
	};

	const handleDateChange = (date: Date) => {
		setSelected(date);
		onChange(moment(date));
	};

	const handleOnMonthChange = (date: Date) => {
		onMonthChange?.(moment(date));
	};

	return (
		<FormCard>
			<div className={`custom-picker ${toggled ? 'toggled picked' : ''}`}>
				<div className='custom-picker__header' onClick={handleTogglePicker}>
					<div className='custom-picker__header__content'>
						<div className='custom-picker__header__content__title'>
							{translation['base.shared.date']}
						</div>
						<div className='custom-picker__header__content__value text-capitalize'>
							{selected
								? format(selected, 'EEEE, dd.MM.yyyy', { locale: ll[language] })
								: translation['base.pickDate']}
						</div>
					</div>
					<div className='custom-picker__header__icon'>
						<i className='fa-solid fa-angle-down' />
					</div>
				</div>
				{toggled && (
					<>
						<hr />
						<div className={`custom-picker__body ${styles.body}`}>
							<DatePicker
								selected={selected}
								onChange={handleDateChange}
								inline
								locale={language}
								minDate={minDate ? new Date(minDate) : undefined}
								maxDate={maxDate ? new Date(maxDate) : undefined}
								onMonthChange={handleOnMonthChange}
								excludeDates={excludeDates}
								renderCustomHeader={({
									date,
									changeYear,
									changeMonth,
									decreaseMonth,
									increaseMonth,
									prevMonthButtonDisabled,
									nextMonthButtonDisabled,
								}) => {
									const title = format(date, 'LLLL y', {
										locale: ll[language],
									});

									return (
										<div className='react-datepicker__custom-header'>
											<div className='react-datepicker__custom-header__title'>
												{title}
											</div>
											<div
												className='react-datepicker__custom-header__prev'
												onClick={decreaseMonth}
											>
												«
											</div>
											<div
												className='react-datepicker__custom-header__next'
												onClick={increaseMonth}
											>
												»
											</div>
										</div>
									);
								}}
							/>
						</div>
					</>
				)}
			</div>
		</FormCard>
	);
};

export default DatePickerCustom;
